<div style="text-align: center; padding: 10px; height: 100vh;">
  <div class="container-center">
    <div class="login-container center-block">
      <div class="logo-container">
        <div style="padding: 20px;">
          <img class="logo" src="../../../assets/Logo_quadratisch.png" style="height: 80px; " />
          <span class="logo-text">ZE Terminal</span>
        </div>
      </div>
      <div class="panel boxshadow">
        <div class="panel-heading">
          <span class="glyphicon glyphicon-lock"></span> Login
          @if (isModal) {
            <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          }
        </div>
        <div class="panel-body">
          <div class="col-md-8 col-md-offset-2">
            @if (formResetToggle) {
              <form class="form-horizontal login" name="loginForm" (ngSubmit)="login()">
                <div class="form-group has-feedback">
                  <mat-form-field class="login" [floatLabel]="'always'" style="width: 100%;">
                    <mat-label>
                      Anmeldename:
                    </mat-label>
                    <input matInput type="text" id="userName" name="userName"
                      [(ngModel)]="userLogin.userName" required />
                    </mat-form-field>
                  </div>
                  <div class="form-group has-feedback">
                    <mat-form-field class="login" [floatLabel]="'always'" style="width: 100%;">
                      <mat-label>
                        Kennwort:
                      </mat-label>
                      <input matInput type="password" id="password" name="password"
                        autocomplete="new-password" [(ngModel)]="userLogin.password" required />
                      </mat-form-field>
                    </div>
                    <div class="form-group">
                      <div class="col-md-offset-2 col-md-10 left">
                        <button type="submit" mat-stroked-button class="submit-button" [disabled]="isLoading">
                          <div style="display: flex;">
                            @if (isLoading) {
                              <div style="padding: 4px; padding-left: 0px;">
                                <mat-spinner [diameter]="'24'"></mat-spinner>
                              </div>
                            }
                            @if (isLoading) {
                              <span style="margin-left: 4px;">Anmeldung läuft...</span>
                            }
                            @if (!isLoading) {
                              <span>Anmelden</span>
                            }
                          </div>
                        </button>
                      </div>
                    </div>
                  </form>
                }
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

